export enum AmbassadorPromotionLevelEnum {
  ConsumerAmbassador = 'ConsumerAmbassador',
  ProfessionalAmbassador = 'ProfessionalAmbassador',
  LeadAmbassador = 'LeadAmbassador'
}
